<script>
import VueContext from 'vue-context';

export default {
    name: "InventoryManagementDashBoard",
data(){
return {
invoiceNo:'-'
};
},
    components: {
        VueContext
    },
}
</script>
<style scoped>
@import  '~vue-context/dist/css/vue-context.css';
</style>
<template>
    <tail-base-layout>
        <template v-slot:content>
            <div class="flex flex-wrap">
                <div class="w-full p-1 my-1 text-center text-white bg-blue-500 rounded">
                    <h5 class="font-medium text-base">Supplier Management</h5>
                </div>
                <div class="w-full md:w-1/4 xl:w-1/4 p-2">
                    <div class="bg-green-100 border-b-4 border-green-600 rounded-lg shadow-lg p-1">
                        <div class="flex flex-row items-center" @click.stop="$refs.menu0.open($event)">
                            <div class="flex-shrink pr-2">
                                <div class="rounded-full p-5 bg-green-600"><i class="fas fa-cogs fa-2x fa-inverse"></i></div>
                            </div>
                            <div class="flex-1 text-right md:text-center">
                                <h5 class="font-bold uppercase text-gray-600">Configurations</h5>
                            </div>
                        </div>
                    </div>
                    <vue-context ref="menu0">
                        <li class="border-b hover:bg-gray-400">
                            <router-link :to="{ name: `suppliers-dashboard.suppliers.index` }">Suppliers</router-link>
                        </li>
                        <li class="border-b hover:bg-gray-400">
                            <router-link :to="{ name: `suppliers-dashboard.supplier-types.index` }">Supplier Types</router-link>
                        </li>
                        <li class="border-b hover:bg-gray-400">
                            <router-link :to="{ name: `suppliers-dashboard.supplier-messages.index` }">Supplier Messages</router-link>
                        </li>
                        <li class="border-b hover:bg-gray-400">
                            <router-link :to="{ name: `suppliers-dashboard.shipping-companies.index` }">Shipping Companies</router-link>
                        </li>
                    </vue-context>
                </div>
                <div class="w-full md:w-1/4 xl:w-1/4 p-2">
                    <div class="bg-blue-100 border-b-4 border-blue-600 rounded-lg shadow-lg p-1">
                        <div class="flex flex-row items-center" @click.stop="$refs.menu1.open($event)">
                            <div class="flex-shrink pr-2">
                                <div class="rounded-full p-5 bg-blue-600"><i class="fas fa-file fa-2x fa-inverse"></i></div>
                            </div>
                            <div class="flex-1 text-right md:text-center">
                                <h5 class="font-bold uppercase text-gray-600">Invoices</h5>
                            </div>
                        </div>
                    </div>
                    <vue-context ref="menu1">
                        <li class="border-b hover:bg-gray-400">
                            <router-link :to="{ name: `suppliers-dashboard.invoice-list.index` }">Invoice List</router-link>
                        </li>
                        <li class="border-b hover:bg-gray-400">
                            <router-link :to="{ name: `suppliers-dashboard.invoice-list.create`, params: { invoiceNo: invoiceNo } }">Add Invoice</router-link>
                        </li>
                    </vue-context>
                </div>
                <div class="w-full md:w-1/4 xl:w-1/4 p-2">
                    <div class="bg-indigo-100 border-b-4 border-indigo-600 rounded-lg shadow-lg p-1">
                        <div class="flex flex-row items-center" @click.stop="$refs.menu2.open($event)">
                            <div class="flex-shrink pr-2">
                                <div class="rounded-full p-5 bg-indigo-600"><i class="fas fa-undo fa-2x fa-inverse"></i></div>
                            </div>
                            <div class="flex-1 text-right md:text-center">
                                <h5 class="font-bold uppercase text-gray-600">GRN</h5>
                            </div>
                        </div>
                    </div>
                    <vue-context ref="menu2">
                        <li class="border-b hover:bg-gray-400">
                            <router-link :to="{ name: `suppliers-dashboard.grn-list.index` }">GRN List</router-link>
                        </li>
                        <li class="border-b hover:bg-gray-400">
                            <router-link :to="{ name: 'suppliers-dashboard.grn-list.create' }">Add GRN</router-link>
                        </li>
                    </vue-context>
                </div>
                <div class="w-full md:w-1/4 xl:w-1/4 p-2">
                    <div class="bg-indigo-100 border-b-4 border-indigo-600 rounded-lg shadow-lg p-1">
                        <div class="flex flex-row items-center" @click.stop="$refs.menu5.open($event)">
                            <div class="flex-shrink pr-2">
                                <div class="rounded-full p-5 bg-indigo-600"><i class="fas fa-folder-open fa-2x fa-inverse"></i></div>
                            </div>
                            <div class="flex-1 text-right md:text-center">
                                <h5 class="font-bold uppercase text-gray-600">Purchase Orders</h5>
                            </div>
                        </div>
                    </div>
                    <vue-context ref="menu5">
                        <li class="border-b hover:bg-gray-400">
                            <router-link :to="{ name: `suppliers-dashboard.purchase-orders.index` }">LPO List</router-link>
                        </li>
                        <li class="border-b hover:bg-gray-400">
                            <router-link :to="{ name: 'suppliers-dashboard.purchase-orders.create' }">Add LPO</router-link>
                        </li>
                    </vue-context>
                </div>
                <div class="w-full md:w-1/4 xl:w-1/4 p-2">
                    <div class="bg-indigo-100 border-b-4 border-indigo-600 rounded-lg shadow-lg p-1">
                        <div class="flex flex-row items-center" @click.stop="$refs.menu3.open($event)">
                            <div class="flex-shrink pr-2">
                                <div class="rounded-full p-5 bg-indigo-600"><i class="fas fa-folder-open fa-2x fa-inverse"></i></div>
                            </div>
                            <div class="flex-1 text-right md:text-center">
                                <h5 class="font-bold uppercase text-gray-600">Journals</h5>
                            </div>
                        </div>
                    </div>
                    <vue-context ref="menu3">
                        <li class="border-b hover:bg-gray-400">
                            <router-link :to="{ name: `suppliers-dashboard.journals.index` }">Journal List</router-link>
                        </li>
                        <li class="border-b hover:bg-gray-400">
                            <router-link :to="{ name: 'suppliers-dashboard.journals.create' }">Add Journal</router-link>
                        </li>
                    </vue-context>
                </div>
                <div class="w-full md:w-1/4 xl:w-1/4 p-2">
                    <div class="bg-indigo-100 border-b-4 border-indigo-600 rounded-lg shadow-lg p-1">
                        <router-link :to="{ name: `suppliers-dashboard.approvals.index` }">
                            <div class="flex flex-row items-center">
                                <div class="flex-shrink pr-2">
                                    <div class="rounded-full p-5 bg-indigo-600"><i class="fas fa-check-double fa-2x fa-inverse"></i></div>
                                </div>
                                <div class="flex-1 text-right md:text-center">
                                    <h5 class="font-bold uppercase text-gray-600">Approvals</h5>
                                </div>
                            </div>
                        </router-link>
                    </div>
                </div>
                <!-- <div class="w-full md:w-1/4 xl:w-1/4 p-2">
                    <div class="bg-indigo-100 border-b-4 border-indigo-600 rounded-lg shadow-lg p-1">
                        <div class="flex flex-row items-center" @click.stop="$refs.menu4.open($event)">
                            <div class="flex-shrink pr-2">
                                <div class="rounded-full p-5 bg-indigo-600"><i class="fas fa-file-excel fa-2x fa-inverse"></i></div>
                            </div>
                            <div class="flex-1 text-right md:text-center">
                                <h5 class="font-bold uppercase text-gray-600">Reports</h5>
                            </div>
                        </div>
                    </div>
                    <vue-context ref="menu4">
                        <li class="border-b hover:bg-gray-400">
                            <router-link :to="{ name: `suppliers-dashboard.supplier-statement-report.index` }">Supplier Statements</router-link>
                        </li>
                    </vue-context>
                </div> -->
            </div>
        </template>
    </tail-base-layout>
</template>
